// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth__Auth--1TInt","AuthForm":"Auth__AuthForm--38dS6"};